import React from 'react';
function isIE() {
  var ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
  var msie = ua.indexOf('MSIE '); // IE 10 or older
  var trident = ua.indexOf('Trident/'); //IE 11

  return msie > 0 || trident > 0;
}
var BrowserSupportAlert = /*#__PURE__*/React.memo(function (props) {
  if (isIE()) {
    alert('We do not support this browser. Please upgrade or use another browser like Chrome or Firefox.');
  }
  return null;
});
BrowserSupportAlert.propTypes = {};
BrowserSupportAlert.defaultProps = {};
BrowserSupportAlert.displayName = 'BrowserSupportAlert';
export default BrowserSupportAlert;